"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
const UnableToFetchIpInfoError_1 = __importDefault(require("./errors/UnableToFetchIpInfoError"));
/**
 * GeolocationServiceClient
 * @param {Object} options options object input data and dependency injection
 * @param {Object} options.fetch change fetch method from whatwg-fetch (optional, default: whatwg-fetch)
 * @param {string} options.protocol the http protocol of the service endpoint
 * @param {string} options.host the host of the service endpoint
 * @param {string} options.path the path of the service endpoint (optional)
 * @param {number} options.retries the number of times the client should retry on network error / service error (optional, default: 3)
 * @param {number} options.delayInSecs the delay between retries (optional, default: 2)
 * @param {Object} options.credentials identifiers and secrets required to hit protected endpoints (optional)
 * @param {string} options.region states the region of the service for signing (optional, default: eu-west-1)
 * @param {RequestMaker} options.requestMaker for overriding request making logic (optional, default: RequestMaker)
 * @throws {UrlConstructionError} when either options.protocol or options.host is missing
 */
class GeolocationServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
    }
    /**
     * Method to fetch information about an IP address
     * @param ip the ip to query (optional, defaults to request IP)
     */
    async fetchIpInfo(ip) {
        return this._makeRequest({
            path: 'info',
            queryParams: ip && { ip }
        });
    }
    async _makeRequest({ method, path, queryParams }) {
        const queryParamString = this.generateQueryParamString(queryParams);
        const url = `${this.url}/api/${path}${queryParamString}`;
        const expectedResponses = [200, 400];
        const response = await this.requestMaker.makeRequest(url, {
            method: method || 'GET'
        }, expectedResponses);
        const body = response.json;
        if (response.status === 400) {
            throw new UnableToFetchIpInfoError_1.default(body && body.reason);
        }
        return body;
    }
    generateQueryParamString(queryParams) {
        const queryParamString = queryParams &&
            Object.keys(queryParams)
                .map(param => `${encodeURIComponent(param)}=${encodeURIComponent(queryParams[param])}`)
                .join('&');
        return queryParamString ? `?${queryParamString}` : '';
    }
}
exports.default = GeolocationServiceClient;
